import { useEffect, useRef, useState } from "react";
import { pageClass, pageHeader, TeamLeadExcelBtn } from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import DeleteMultipleLeads from "../Components/Modals/DeleteMultipleLeads";
import { useLocation, useNavigate } from "react-router-dom";
import usePaginatedData from "../Components/Utils/UsePagination";
import { Controller, useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { AssignUserAPI, GetAllCompanyAPI, GetallDashboardLeadsAPI } from "../API/Api";
import moment from "moment";
import DeleteLeadModal from "../Components/Modals/DeleteLeadModal";
import AddLeadd from "../Components/Modals/AddLeadd";
import { openModal } from "../Redux/Slice/LoginSlice";
import ModifyCallTimeModal from "../Components/Modals/ModifyCallTimeModal";
import { downloadCSV, truncateText } from "../Components/Utils/CommonFuntion";
import { toast } from "react-toastify";
import { Checkbox } from "antd";
import { IconChevronLeft, IconEye, IconPhone } from "@tabler/icons-react";
import { LeadStatusStyles } from "../Components/Utils/StaticData";

export default function TotalLeads() {
  const UserDetails = useSelector((state) => state?.login?.userDetails);
  const companyDetails = useSelector((state) => state?.login?.userDetails?.company);
  const location = useLocation();
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);
  const { title, dateRange } = location.state || {};
  const formattedTitle = title?.trim().replace(/\s+/g, "");
  const [AssignUsers, setAssignUsers] = useState([]);
  const [Company, setCompany] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [RowId, setRowId] = useState([]);
  const [RowCheck, setRowCheck] = useState(false);
  const dispatch = useDispatch();

  const initialFilterState = {
    p: 1,
    id: UserDetails?._id || "",
    dashboardStatus: formattedTitle,
    role: UserDetails?.role?.roleName || "",
    company: UserDetails?.role?.roleName === "SuperAdmin" ? "" : UserDetails?.company?._id,
    startDate: dateRange?.startDate || "",
    endDate: dateRange?.endDate || "",
  };

  const handleNavigateTotalLeads = () => {
    if (location.state?.from === "dashboard") {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  const { register,control, formState: { errors }, } = useForm();
  const navigate = useNavigate();
  const [filterObject, setFilterObject] = useState({
    ...initialFilterState,
    p: location.state?.restorePage || 1,
  });
  const {
    filterData: LeadsData,
    pageNo,
    records,
    totalRecord,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
    nextIsValid,
    prevIsValid,
    loader,
  } = usePaginatedData(1, location.state?.restoreRecords || 50, GetallDashboardLeadsAPI, filterObject);
  const handleNavigate = (row) => {
    navigate("/teamleads-detail", {
      state: {
        leadData: row,
        fromPage: pageNo,
        restoreRecords: records,
        from: "totalLeads",
        title,
        origin: location.state?.from
      }
    });
  };

  // Function to select/deselect a single row
  const handleRowSelect = (rowId, checked) => {
    setSelectedRows((prevSelected) => {
      let updatedSelection;
      if (checked) {
        updatedSelection = [...prevSelected, rowId]; // Select the row
      } else {
        updatedSelection = prevSelected.filter((id) => id !== rowId); // Deselect the row
      }

      // Set RowCheck to true only if there are still selected rows
      setRowCheck(updatedSelection.length > 0);
      setRowId(updatedSelection);
      return updatedSelection;
    });
  };
  const resetSelection = () => {
    setRowCheck(false);
    setRowId([]);
    setSelectedRows([]);
  };
  // "Select All" functionality
  const handleSelectAll = (checked) => {
    if (checked) {
      const allRowIds = LeadsData?.map((row) => row?._id);
      setSelectedRows(allRowIds);
      setRowId(allRowIds);
      setRowCheck(true);
    } else {
      setSelectedRows([]);
      setRowId([]);
      setRowCheck(false);
    }
  };
  const tableColumns = [
    {
      field: "select",
      header: LeadsData?.length > 0 && (
        <Checkbox
          checked={
            selectedRows.length === LeadsData.length &&
            LeadsData.length > 0
          }
          onChange={(e) => handleSelectAll(e.target.checked)}
        />
      ),
      style: true,
      className: "col-select",
      body: (row) => (
        <Controller
          name={`selected_${row._id}`}
          control={control}
          render={() => (
            <Checkbox
              checked={selectedRows.includes(row._id)}
              onChange={(e) => handleRowSelect(row._id, e.target.checked)}
            />
          )}
        />
      ),
    },
    {
      field: "sr_no",
      header: "Sr No",
      style: true,
      body: (row, meta) => {
        return <h6>{(pageNo - 1) * Number(records) + meta.rowIndex + 1}</h6>;
      }
    },
    {
      field: "createdAt",
      header: "created At",
      style: true,
      body: (row) => (
        <h6>{moment(row.createdAt).format("DD-MM-YYYY") || "-----"}</h6>
      ),
    },
    {
      field: "location",
      header: "Location",
      style: true,
      className: "col-location",
      body: (row) => {
        const fullText = `${row?.city || ""}${row?.city && row?.state ? ", " : ""}${row?.state || ""}`;
        return (
          <>
            <h6 title={fullText}>
              {truncateText(fullText)}
            </h6>
            <h6>{row?.pincode || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "fullName",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const fullName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
        return (
          <h6 title={fullName || "-----"}>
            {truncateText(fullName, 30)}
          </h6>
        );
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => (
        <h6 title={row?.email || "-----"}>
          {truncateText(row?.email || "", 30)}
        </h6>
      ),
    },
    {
      field: "phoneNumber",
      header: "Phone Details",
      style: true,
      body: (row) => {
        return (
          <>
            <h6>{row?.phoneNumber || "----"}</h6>
          </>
        );
      },
    },
    {
      field: "alternateNumber",
      header: "Alternate Number",
      style: true,
      body: (row) => <h6>{row?.alternateNumber || "------"}</h6>,
    },
    {
      field: "leadSource",
      header: "Lead Source",
      style: true,
      body: (row) => <h6>{row?.leadSource || "-----"}</h6>,
    },
    {
      field: "product",
      header: "Product",
      style: true,
      body: (row) => <h6>{row?.product || "------"}</h6>,
    },
    {
      field: "assigned_to",
      header: "Assigned To",
      style: true,
      body: (row) => (
        <h6>
          {row?.assigned_to?.first_name && row?.assigned_to?.last_name
            ? `${row.assigned_to.first_name} ${row.assigned_to.last_name}`
            : "----"}
        </h6>
      ),
    },
    {
      field: "followUpDetails",
      header: "FDetails",
      style: true,
      body: (row) => {
        const followDate = row?.followDate;
        const followTime = row?.followTime;
        const followDateDetails = (followDate) ? moment(row?.followDate).format("DD-MM-YYYY") : "-----";
        const followTimeDetails = (followTime) ? `${followTime}` : "-----";
        return(
          <>
            <h6>{followDateDetails}</h6>
            <h6>{followTimeDetails}</h6>
          </>
        );
      },
    },
    {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName || "-----"}</h6>,
    },
    {
      field: "leadStatus",
      header: "Lead Status",
      style: true,
      body: (row) => <LeadStatusStyles leadStatus={row?.leadStatus} />,
    },
    {
      field: "remark",
      header: "Remark",
      style: true,
      body: (row) => <h6 className='break-words whitespace-pre-line min-w-[20rem]'>{row?.remark || "-----"}</h6>,
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      className: "col-actions",
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleNavigate(row);
            }}
            className="py-1 rounded-lg flex justify-center"
          >
            <IconEye stroke={1.5} size={24} color="#000"  />
          </button>
          <AddLeadd edit={true} rowdata={row} Company={Company} iniAssignUsers={AssignUsers} filterRecords={() => filterRecords(true)} />
          {row?.assigned_to?._id === UserDetails?._id ? (
            <button
              onClick={(e) => {
                e.preventDefault();
                dispatch(
                  openModal({
                    isOpenModal: true,
                    modalData: { rowdata: row },
                  })
                );
              }}
            >
              {/* <Call size={18} className="text-black" color="#000" /> */}
              <IconPhone stroke={1.5} size={23} color="#000"  />
            </button>
          ) : null}
          {(UserDetails?.role?.roleName == "SuperAdmin" ||
            UserDetails?.role?.roleName == "Admin") && (
              <DeleteLeadModal row={row} filterRecords={() => filterRecords(true)} />
            )}
        </div>
      ),
    },
  ];

  const allowedFields = companyDetails?.allowedLeadTableFields || [];

  let filteredColumns = tableColumns;

  if (allowedFields.length > 0) {
    filteredColumns = tableColumns.filter((col) => {
      return (
        col.field === "select" ||
        col.field === "sr_no" ||
        col.field === "createdAt" ||
        col.field === "actions" ||
        allowedFields.includes(col.field)
      );
    });
  }


  const filterSubmit = async (data) => {
    const payload = {
      ...filterObject,
      p: pageNo,
      dashboardStatus: formattedTitle,
      role: UserDetails?.role?.roleName || "",
      company: UserDetails?.role?.roleName === "SuperAdmin" ? "" : UserDetails?.company?._id,
      startDate: dateRange?.startDate || "",
      endDate: dateRange?.endDate || "",
    };
    setFilterObject(payload);
  };

  const filterRecords = (maintainPage = false) => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      const currentPage = maintainPage ? pageNo : 1;
      await fetchData({ ...filterObject, p: currentPage });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  const getallCompany = async () => {
    try {
      const parentCompanyId = UserDetails?.role?.roleName === "SuperAdmin" ? UserDetails?.company?._id : "";
      const res = await GetAllCompanyAPI(parentCompanyId);
      setCompany(res?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };
  const handleCompanySelect = async (companyId) => {
    try {
      let response = await AssignUserAPI({
        id: UserDetails?._id,
        role: UserDetails?.role?.roleName,
        company: UserDetails?.role?.roleName !== "SuperAdmin" ? companyId : "",
      });
      setAssignUsers(response?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    if (UserDetails?.role?.roleName === "SuperAdmin") {
      getallCompany();
    }
    handleCompanySelect(UserDetails?.company?._id);
  }, []);

  const submitPdfExcel = async () => {
    const handleExcelDownload = async () => {
      try {
        const payload = {
          ...filterObject,
          records: 0,
        };
        var response = await GetallDashboardLeadsAPI(payload);
        const LeadsDataAll = response?.data?.filteredData;

        const Header = [
          "firstName",
          "lastName",
          "createdAt",
          "state",
          "city",
          "pincode",
          "email",
          "phoneNumber",
          "alternateNumber",
          "leadSource",
          "followDate",
          "followTime",
          "leadStatus",
          "product",
          "assigned_to",
          "remark",
        ];

        const formattedLeadsData = LeadsDataAll.map((lead) => (
          {
            ...lead,
            assigned_to: `${lead?.assigned_to?.first_name || ""} ${lead?.assigned_to?.last_name || ""}`.trim(),
            company: lead?.company?.companyName || "",
          }));

        downloadCSV(Header, formattedLeadsData, `${formattedTitle}`);
      } catch (err) {
        console.log("Error:", err);
        toast.error("Failed to download Excel");
      }
    };
    handleExcelDownload();
  };

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="mb-[20px] rounded-[4px] w-[56px] h-[48px] bg-[var(--bg-base-color)] flex items-center justify-center cursor-pointer">
            <button
              onClick={(e) => {
                e.preventDefault();
                handleNavigateTotalLeads();
              }}
            >
              <IconChevronLeft stroke={1.5} size={23} color="#FFFFFF"  />
            </button>
          </div>
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader}`}>{title}</h1>
            <button className={TeamLeadExcelBtn} onClick={() => submitPdfExcel()}>
              Excel
            </button>
          </div>
          {RowCheck &&  (
            <div className="bg-white rounded-xl mt-3">
              <div className="flex items-center justify-start pt-4">
                <div className="w-[200px]">
                  <DeleteMultipleLeads
                    RowId={RowId}
                    count={RowId.length}
                    filterRecords={() => filterRecords(true)}
                    resetSelection={resetSelection}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="mt-4">
            <Table
              key={selectedRows.length}
              columns={filteredColumns}
              data={LeadsData}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              records={records}
              totalRecord={totalRecord}
              loading={loader}
            />
          </div>
        </div>
      </div>
      <ModifyCallTimeModal
        edit={true}
        filterRecords={() => filterRecords(true)}
        hideTrigger={true}
      />
    </>
  );
}
